import CoreInstance from '../CoreInstance';

const organizations = {
  /**
   * This endpoints returns the detailed version of the center list
   */
  getCenters: () => CoreInstance.get('/organizations/centers'),
};

const centers = {
  postCenterConfig: body => CoreInstance.post('/centers/center_configuration', body),
};

export default {
  organizations,
  centers,
};
